import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetCustomerGiftVouchers = (params: any) =>
    request({
        url:
            ApiURL.Query.GetGiftVouchers +
            '?Region=' +
            params.regionId +
            '&CustomerId=' +
            params.customerId +
            '&SkipCount=' +
            params.skipCount +
            '&MaxResultCount=' +
            params.maxResultCount +
            '&SortPropertyName=' +
            params.sortPropertyName +
            '&SortValue=' +
            params.sortValue,
        method: RequestType.GET,
    });

const DeleteGiftVoucher = (params: any) =>
    request({
        url: ApiURL.Query.UpdateGiftVoucherStatus,
        method: RequestType.POST,
        data: params,
    });

const PostGiftVoucher = (params: any) =>
    request({
        url: ApiURL.Query.PostGiftVoucher,
        method: RequestType.POST,
        data: params,
    });

const GetGiftVoucherById = (params: any) =>
    request({
        url: ApiURL.Query.GetGiftVoucherById,
        method: RequestType.GET,
        params: params,
    });

const GiftVoucherQuery = {
    GetCustomerGiftVouchers,
    DeleteGiftVoucher,
    PostGiftVoucher,
    GetGiftVoucherById,
};

export default GiftVoucherQuery;
